import React, {Component} from 'react';

import styles from './Spinner.css'

export default class Spinner extends Component {
    render() {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loader}>
                    <div className={styles.loadingSlide}>
                        <div className={styles.slide}></div>
                        <div className={styles.slide}></div>
                        <div className={styles.slide}></div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js